import React, { Fragment, useContext, useEffect, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";


import { MdFamilyRestroom, MdTipsAndUpdates, MdKeyboardArrowDown, MdKeyboardArrowRight, MdKeyboardArrowUp } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown } from 'react-icons/io';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { AiOutlinePlusCircle, AiFillFolder, AiFillFile, AiFillCheckCircle } from 'react-icons/ai'

import { BsFillPersonFill, BsClock } from 'react-icons/bs'
import Renderif from '../../components/renderif';
import SideMenu from '../../components/sidemenu';
import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { useNavigate } from 'react-router-dom';
import AgregarTip from './agregar_tip_psico';
import AgregarDocumento from './agregar_documento_psico';
import { AuthContext } from '../../context/auth_context';
import { Service } from '../../services/api';
import AgregarTag from './agregar_tag_psico';






export default function HomePsico() {

    const navigate = useNavigate();
    const { user } = useContext(AuthContext)

    const [state, setState] = useState({
        tab: 0,
        show_cita_detail_id: null,
        show_add: '',
        next_citas: [],
        prev_citas: [],
        citas: [],
        filter: '',
        search: '',
        date_selected: null
    })
    function addHours(date, hours) {
        const hoursToAdd = hours * 60 * 60 * 1000;
        date.setTime(date.getTime() + hoursToAdd);
        return date;
    }

    useEffect(() => {
        const init = async () => {
            let citas = await Service('GET', 'Appointment?id=', user.id);
            console.log(citas)
            // console.log(user.id)
            let today = new Date();

            console.log(today.setHours(today.getHours() - 1));
            let next_citas = citas?.data.data.filter((cita) => new Date(cita[0].dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.date)) - Number(new Date(citaB.date)))
            let prev_citas = citas?.data.data.filter((cita) => new Date(cita[0].dateOfEvent) < today).sort((citaA, citaB) => Number(new Date(citaA.date)) - Number(new Date(citaB.date)))
            next_citas.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime() );
            prev_citas.sort((a, b) => new Date(b[0].dateOfEvent).getTime() - new Date(a[0].dateOfEvent).getTime() );
            console.log(next_citas)

            setState({ ...state, next_citas, prev_citas })
        }
        init();
        return () => { }
    }, [])

    const filter = (data) => {
        return data;

        if (state.date_selected === null) {

            let filtered = data.filter((item) =>
                item.description.toUpperCase().includes(state.search.toUpperCase()) ||
                item.specialist.firstName.toUpperCase().includes(state.search.toUpperCase()) ||
                item.patient.firstName.toUpperCase().includes(state.search.toUpperCase()) ||
                item.patient.proceedings.toUpperCase().includes(state.search.toUpperCase())
            )
            return filtered;

        }

        let dates = []
        data.map((item) => {
            let event = new Date(item.dateOfEvent);
            if (
                event.getDate() === state.date_selected.getDate() &&
                event.getMonth() === state.date_selected.getMonth() &&
                event.getDay() === state.date_selected.getDay()
            ) {
                dates.push(item)
            }
        })
        return dates;


    }

    const arr = [1, 1, 1, 1, 1, 1, 1]

    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var months = new Array(7);
    months[0] = "January";
    months[1] = "Febrary";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "Octuber";
    months[10] = "November";
    months[11] = "December";


    return (
        <>

            <Renderif isTrue={state.show_add === 'agregar-tip'}>
                <AgregarTip step={1} onCancel={() => { setState({ ...state, show_add: '' }) }}></AgregarTip>
            </Renderif>

            <Renderif isTrue={state.show_add === 'agregar-tag'}>
                <AgregarTag onCancel={() => { setState({ ...state, show_add: '' }) }}></AgregarTag>
            </Renderif>

            <Renderif isTrue={state.show_add === 'agregar-doc'}>
                <AgregarDocumento step={1} onCancel={() => { setState({ ...state, show_add: '' }) }}></AgregarDocumento>
            </Renderif>

            <div className='container-fluid h-100 d-flex'>

                <SideMenu></SideMenu>



                <div className='col hide-scroll'>

                    <div className='d-flex px-1 py-3 p-lg-3'>
                        <div className='avatar avatar--mid'></div>
                        <div className='ms-2'>
                            <div className='f-16 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                            <div className='f-14 text-gray line-0'>{user.email}</div>
                        </div>
                    </div>


                    <div className='container-fluid p-0'>

                        <div className='row m-0'>
                            <div className='col-12 col-xl-12 m-0 p-0'>


                                <div className='d-flex align-items-center px-1 py-3 p-lg-3'>

                                    <div className='d-flex'>
                                        <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => {
                                            setState({ ...state, tab: 0 })
                                        }}>Próximas Citas <span className='text-blue f-12 bold ms-2'>{state.next_citas.length}</span></div>

                                        <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => {
                                            setState({ ...state, tab: 1 })
                                        }}>Citas Anteriores <span className='text-blue f-12 bold ms-2'>{state.prev_citas.length}</span></div>
                                    </div>

                                    <div className='col'></div>

                                    <div className='d-block d-xl-none'>
                                        <DropDown
                                            title='Agregar'
                                            style={'primary'}
                                            icon={<AiOutlinePlusCircle size={20} color={'white'} />}
                                            _onChange={(evt) => {
                                                setState({ ...state, show_add: evt.value })
                                            }}
                                        >

                                            <DropDownOption value='agregar-tip' >Agregar Tip</DropDownOption>
                                            <DropDownOption value='agregar-tag' >Agregar Etiqueta</DropDownOption>
                                            <DropDownOption value='agregar-doc' >Agregar Documento</DropDownOption>
                                            {/* <DropDownOption>Agregar Plan</DropDownOption>
                                    <DropDownOption>Agregar Banner</DropDownOption> */}
                                        </DropDown>


                                    </div>


                                    <div className='d-none d-xl-flex '>

                                        <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                            setState({ ...state, show_add: 'agregar-tip' })
                                        }}>
                                            <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                            <div className='px-1'>Agregar Tip</div>
                                        </div>


                                        <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                            setState({ ...state, show_add: 'agregar-tag' })
                                        }}>
                                            <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                            <div className='px-1'>Agregar Etiqueta</div>
                                        </div>

                                        <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                            setState({ ...state, show_add: 'agregar-doc' })
                                        }}>
                                            <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                            <div className='px-1'>Agregar Documento</div>
                                        </div>
                                        {/* <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={()=>{}}>
                                    <div className='ps-0'> <AiOutlinePlusCircle size={22}/></div>
                                    <div className='px-1'>Agregar Plan</div>
                                </div>
                                <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={()=>{}}>
                                    <div className='ps-0'> <AiOutlinePlusCircle size={22}/></div>
                                    <div className='px-1'>Agregar Banner</div>
                                </div> */}
                                    </div>

                                </div>

                                <div className='w-100 d-flex px-1 px-lg-3'>
                                    {/* <div className='pe-1'><input type="date" className='input--light'></input></div> */}
                                    <div className='col'><input type='text' value={state.filter} onChange={(evt) => {
                                        setState({ ...state, filter: evt.currentTarget.value })
                                    }} placeholder='Buscar paciente' className='input--light'></input></div>
                                </div>

                                <Renderif isTrue={state.tab === 0}>

                                    <div className='d-md-none px-1 py-3'>
                                        {arr.map((item, i) => {
                                            return (
                                                <CitaItem key={i}></CitaItem>
                                            )
                                        })}
                                    </div>
                                    <div className='p-1 p-lg-3 d-none d-md-block'>
                                        <div className='bv-table'>
                                            <table className='w-100'>
                                                <thead>
                                                    <tr>
                                                        <td>
                                                            <div className='d-flex align-items-center'>

                                                                <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div>
                                                                <div className='text-gray line-0 f-12 bold'>Paciente</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Fecha</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><BsClock size={12} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Hora</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Sesión</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                                <div className='text-gray f-12 bold line-0'>Acuerdos</div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><AiFillFolder size={16} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Expediente</div>
                                                            </div>
                                                        </td>
                                                        <td></td>


                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {arr.map((item,i)=>{
                                        return (
                                            <Fragment key={i}>
                                                <tr className="highlight-hover--light" onClick={()=>{
                                                    navigate('/admin/cita');
                                                }}>
                                                    <td>
                                                        <div>
                                                            <div className='text-gray f-12'>Nombre</div>
                                                            <div className='text-gray f-10'>Email</div>
                                                        </div>
                                                    </td>

                                                    <td><div className='text-gray f-12'>Fecha</div></td>
                                                    <td><div className='text-gray text-center f-12'>90:00</div></td>
                                                    <td><div className='text-black bold f-12 text-center'>0</div></td>
                                                    <td><div className='text-black bold f-12 text-center'>0</div></td>
                                                 
                                                    <td><div className='text-gray f-12 ps-2'>T1234790A</div></td>
                                                    <td>
                                                        <div className={`bv-pill ${i==0 ? 'bv-pill--primary' : 'bv-pill--light'}`}>
                                                            Video Llamada
                                                        </div>
                                                    </td>
                                                    
                                                </tr>
                                                

                                            
                                            </Fragment>
                                        )
                                    })} */}
                                                    {filter(state.next_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase())))).map((cita, i) => {
                                                        let item = cita[0]
                                                        console.log(cita)

                                                        return (
                                                            <Fragment key={i}>
                                                                <tr className="highlight-hover--light" onClick={(evt) => {
                                                                    if (cita.length > 1) {
                                                                        evt.stopPropagation();
                                                                        setState({ ...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i })
                                                                        return;
                                                                    };
                                                                    navigate('/admin/cita/' + item.id);
                                                                }}>
                                                                    <td >
                                                                        <div className='d-flex'>

                                                                            <div className=''>
                                                                                <div className='text-gray f-12'>{item.patient.firstName} {item.patient.lastName}</div>
                                                                                <div className='text-gray f-10'>{item.patient.email}</div>
                                                                            </div>
                                                                            <div className='col'></div>

                                                                            <Renderif isTrue={cita.length > 1}>
                                                                                <div className='d-flex ms-4'>

                                                                                    {cita.map((memeber, j) => {
                                                                                        return (
                                                                                            <div className='overlap-content'>
                                                                                                <div key={j} className='avatar avatar--small overlap-content'></div>
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                            </Renderif>
                                                                        </div>

                                                                    </td>
                                                                    <td><div className='text-gray f-12'>{weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()}</div></td>
                                                                    <td><div className='text-gray text-center f-12'>{new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}</div></td>
                                                                    <td><div className='text-black bold f-12 text-center'>{item.numberOfSession}</div></td>
                                                                    <td><div className='text-black bold f-12 text-center'>{item.agreements.length}</div></td>

                                                                    <td><div className='text-gray f-12 ps-2 '>#{item.patient.proceedings}</div></td>
                                                                    <td className=''>
                                                                        <Renderif isTrue={cita.length === 1}>
                                                                            <div className={`bv-pill bv-pill--primary cursor-pointer`} onClick={(evt) => {
                                                                                evt.stopPropagation();
                                                                                window.open(item.sessionUrl, '_blank')
                                                                            }}>
                                                                                Video Llamada
                                                                            </div>
                                                                        </Renderif>
                                                                        <Renderif isTrue={cita.length !== 1}>
                                                                            <div className={`bv-pill bv-pill-- cursor-pointer`} onClick={(evt) => {
                                                                                evt.stopPropagation();
                                                                                setState({ ...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i })
                                                                                // window.open(item.sessionUrl, '_blank')
                                                                            }}>

                                                                                {state.show_cita_detail_id === i ? 'Ver Familia' : 'Ver Familia'}
                                                                                {state.show_cita_detail_id === i ?
                                                                                    <MdKeyboardArrowDown size={20}></MdKeyboardArrowDown>
                                                                                    :
                                                                                    <MdKeyboardArrowUp size={20}></MdKeyboardArrowUp>
                                                                                }



                                                                            </div>
                                                                        </Renderif>
                                                                        {/* <div>{cita.length}</div> */}


                                                                    </td>


                                                                </tr>
                                                                <Renderif isTrue={state.show_cita_detail_id === i}>


                                                                    {cita.map((sub_item) => {

                                                                        // if(sub_item.id === item.id) return;


                                                                        return (
                                                                            <tr className='bg-sky cursor-pointer' onClick={() => {
                                                                                navigate('/admin/cita/' + sub_item.id);
                                                                            }}>
                                                                                <td>
                                                                                    <div>
                                                                                        <div className='text-gray f-12'>{sub_item.patient.firstName} {sub_item.patient.lastName}</div>
                                                                                        <div className='text-gray f-10'>{sub_item.patient.email}</div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div>
                                                                                        <div className='text-gray f-12'>{sub_item.specialist.firstName} {sub_item.specialist.lastName}</div>
                                                                                        <div className='text-gray f-10'>{sub_item.specialist.email}</div>
                                                                                    </div>
                                                                                </td>
                                                                                <td><div className='text-gray f-12'>{weekday[new Date(sub_item.dateOfEvent).getDay()]} {new Date(sub_item.dateOfEvent).getDate()} {months[new Date(sub_item.dateOfEvent).getMonth()]} {new Date(sub_item.dateOfEvent).getFullYear()}</div></td>
                                                                                <td><div className='text-gray text-center f-12'>{new Date(sub_item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}</div></td>
                                                                                <td><div className='text-black bold f-12 text-center'>{sub_item.numberOfSession}</div></td>
                                                                                <td><div className='text-black bold f-12 text-center'>{sub_item.agreements.length}</div></td>

                                                                                <td><div className='text-gray f-12 ps-2 text-center'>#{sub_item.patient.proceedings}</div></td>
                                                                                <td>
                                                                                    <div className={`bv-pill bv-pill--primary cursor-pointer`} onClick={(evt) => {
                                                                                        evt.stopPropagation();
                                                                                        window.open(sub_item.sessionUrl, '_blank')
                                                                                    }}>
                                                                                        Videollamada
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}


                                                                </Renderif>



                                                            </Fragment>
                                                        )
                                                    })}

                                                </tbody>

                                            </table>

                                            <div className='pt-5'></div>
                                            <div className='mt-5'></div>

                                            <div className='d-flex align-items-center mt-5 p-2'>

                                                <div className='text-gray f-12 line-0'>Mostrar</div>


                                                <div className='mx-2'>
                                                    <DropDown
                                                        title=''
                                                        open={false}
                                                        defaultValue={5}
                                                        _onChange={(evt) => {
                                                            console.log(evt)
                                                        }}>
                                                        <DropDownOption value={5} label="5">
                                                            <div className='f-14 text-gray'>5</div>
                                                        </DropDownOption>
                                                        <DropDownOption value={10} label="10">
                                                            <div className='f-14 text-gray'>10</div>
                                                        </DropDownOption>



                                                    </DropDown>
                                                </div>



                                                {/* <div className='d-flex bv-dropdown mx-2'>
                                        <div className='text-black bold f-12 ms-1'>5</div>
                                        <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                                </div> */}


                                                <div className='text-gray f-12 line-0'>Por Página</div>
                                                <div className='col'></div>


                                            </div>
                                        </div>
                                    </div>
                                </Renderif>


                                <Renderif isTrue={state.tab === 1}>
                                    <div className='p-1 p-lg-3'>
                                        <div className='bv-table'>
                                            <table className='w-100'>
                                                <thead>
                                                    <tr>
                                                        <td>
                                                            <div className='d-flex align-items-center'>


                                                                <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div>
                                                                <div className='text-gray line-0 f-12 bold'>Paciente</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Fecha</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><BsClock size={12} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Hora</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0'>Sesión</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                                <div className='text-gray f-12 bold line-0'>Acuerdos</div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon'><AiFillFolder size={16} color="#777777" /></div>
                                                                <div className='text-gray f-12 bold line-0 text-center'>Expediente</div>
                                                            </div>
                                                        </td>
                                                        <td></td>



                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {state.prev_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase()))).map((cita, i) => {
                                                        let item = cita[0]
                                                        return (
                                                            <Fragment key={i}>
                                                                <tr className="highlight-hover--light " onClick={() => {
                                                                    setState({ ...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i })
                                                                    // if(cita.length > 1) {
                                                                    //     return
                                                                    // }
                                                                    // navigate('/administrador/cita/' + item.id);
                                                                }}>
                                                                    <td >
                                                                        <div className='d-flex'>

                                                                            <div className=''>
                                                                                <div className='text-gray f-12'>{item.patient.firstName} {item.patient.lastName}</div>
                                                                                <div className='text-gray f-10'>{item.patient.email}</div>
                                                                            </div>
                                                                            <div className='col'></div>

                                                                            <Renderif isTrue={cita.length > 1}>
                                                                                <div className='d-flex ms-4'>

                                                                                    {cita.map((memeber, j) => {
                                                                                        return (
                                                                                            <div className='overlap-content'>
                                                                                                <div key={j} className='avatar avatar--small overlap-content'></div>
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                            </Renderif>
                                                                        </div>

                                                                    </td>


                                                                    <td onClick={() => {
                                                                        // navigate('/administrador/cita/' + item.id);
                                                                    }}><div className='text-gray f-12'>{weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()}</div></td>
                                                                    <td onClick={() => {
                                                                        // navigate('/administrador/cita/' + item.id);
                                                                    }}><div className='text-gray text-center f-12'>{new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}</div></td>
                                                                    <td onClick={() => {
                                                                        // navigate('/administrador/cita/' + item.id);
                                                                    }}><div className='text-black bold f-12 text-center'>{item.numberOfSession}</div></td>
                                                                    <td onClick={() => {
                                                                        // navigate('/administrador/cita/' + item.id);
                                                                    }}><div className='text-black bold f-12 text-center'>{item.agreements.length}</div></td>

                                                                    <td onClick={() => {
                                                                        // navigate('/administrador/cita/' + item.id);
                                                                    }}><div className='text-gray f-12 ps-2 text-center'>#{item.patient.proceedings}</div></td>
                                                                    <td>


                                                                        <div className={`bv-pill cursor-pointer ${state.show_cita_detail_id === i ? 'bv-pill--primary' : 'bv-pill--'}`} onClick={() => {

                                                                            setState({ ...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i })
                                                                        }}>
                                                                            {state.show_cita_detail_id === i ? 'Ver Seguimiento' : 'Ver Seguimiento'}

                                                                            {state.show_cita_detail_id === i ?
                                                                                <MdKeyboardArrowDown size={20}></MdKeyboardArrowDown>
                                                                                :
                                                                                <MdKeyboardArrowUp size={20}></MdKeyboardArrowUp>}




                                                                        </div>



                                                                    </td>

                                                                </tr>
                                                                <Renderif isTrue={state.show_cita_detail_id === i}>


                                                                    {cita.map((sub_item) => {

                                                                        // if(sub_item.id === item.id) return;


                                                                        return (
                                                                            <>
                                                                                <tr className='bg-sky cursor-pointer' onClick={() => {
                                                                                    navigate('/admin/cita/' + sub_item.id);
                                                                                }}>
                                                                                    <td>
                                                                                        <div>
                                                                                            <div className='text-gray f-12'>{sub_item.patient.firstName} {sub_item.patient.lastName}</div>
                                                                                            <div className='text-gray f-10'>{sub_item.patient.email}</div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            <div className='text-gray f-12'>{sub_item.specialist.firstName} {sub_item.specialist.lastName}</div>
                                                                                            <div className='text-gray f-10'>{sub_item.specialist.email}</div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td><div className='text-gray f-12'>{weekday[new Date(sub_item.dateOfEvent).getDay()]} {new Date(sub_item.dateOfEvent).getDate()} {months[new Date(sub_item.dateOfEvent).getMonth()]} {new Date(sub_item.dateOfEvent).getFullYear()}</div></td>
                                                                                    <td><div className='text-gray text-center f-12'>{new Date(sub_item.dateOfEvent).getHours()}:{new Date(sub_item.dateOfEvent).getMinutes()}</div></td>
                                                                                    <td><div className='text-black bold f-12 text-center'>{sub_item.numberOfSession}</div></td>
                                                                                    <td><div className='text-black bold f-12 text-center'>{sub_item.agreements.length}</div></td>

                                                                                    <td><div className='text-gray f-12 ps-2 text-center'>#{sub_item.patient.proceedings}</div></td>
                                                                                    <td>
                                                                                        {/* <div className={`bv-pill bv-pill--green cursor-pointer`} onClick={(evt) => {
                                                                                evt.stopPropagation();
                                                                                window.open(sub_item.sessionUrl, '_blank')
                                                                            }}>
                                                                                Ver Seguimiento
                                                                            </div> */}
                                                                                    </td>
                                                                                </tr>
                                                                                <Renderif isTrue={state.show_cita_detail_id === i}>
                                                                                    <tr className='bg-light'>
                                                                                        <td colSpan={8} className='p-0'>
                                                                                            <CitaDetail cita={sub_item}></CitaDetail>
                                                                                        </td>
                                                                                    </tr>
                                                                                </Renderif>
                                                                            </>

                                                                        )
                                                                    })}
                                                                    {/* <Renderif isTrue={state.show_cita_detail_id === i}>
                                                                    <tr className='bg-light'>
                                                                        <td colSpan={8} className='p-0'>
                                                                            <CitaDetail cita={item}></CitaDetail>
                                                                        </td>
                                                                    </tr>
                                                                </Renderif> */}


                                                                </Renderif>



                                                            </Fragment>
                                                        )
                                                    })}

                                                </tbody>

                                            </table>

                                            <div className='pt-5'></div>
                                            <div className='mt-5'></div>

                                            <div className='d-flex align-items-center mt-5 p-2'>

                                                <div className='text-gray f-12 line-0'>Mostrar</div>


                                                <div className='mx-2'>
                                                    <DropDown
                                                        title=''
                                                        open={false}
                                                        defaultValue={5}
                                                        _onChange={(evt) => {
                                                            console.log(evt)
                                                        }}>
                                                        <DropDownOption value={5} label="5">
                                                            <div className='f-14 text-gray'>5</div>
                                                        </DropDownOption>
                                                        <DropDownOption value={10} label="10">
                                                            <div className='f-14 text-gray'>10</div>
                                                        </DropDownOption>



                                                    </DropDown>
                                                </div>



                                                {/* <div className='d-flex bv-dropdown mx-2'>
                                        <div className='text-black bold f-12 ms-1'>5</div>
                                        <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                                </div> */}


                                                <div className='text-gray f-12 line-0'>Por Página</div>
                                                <div className='col'></div>


                                            </div>
                                        </div>
                                    </div>
                                </Renderif>



                            </div>

                            {/* <div className='col-12 col-xl-3 m-0 p-0 pe-1 pe-lg-3'>

                                <div className='d-flex flex-column flex-md-row flex-xl-column'>

                                    <div className='col py-2 py-xl-0'>
                                        <BVCalendar date={state.date_selected} onChange={(evt) => {
                                            setState({ ...state, date_selected: evt })
                                        }}></BVCalendar>
                                    </div>

                                   

                                </div>





                            </div> */}
                        </div>
                    </div>



                </div>
            </div>
        </>
    )
}

const CitaDetail = ({ cita }) => {
    console.log(cita)
    const [state, setState] = useState({
        tab: 0
    })
    const arr = [1, 1, 1, 1, 1, 1, 1]
    return (
        <div className='d-grid'>
            <div className='d-flex p-1'>
                <div className='col'></div>
                <div className='py-2 d-flex'>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 0 }) }}>
                        Información General
                    </div>
                    <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 1 }) }}>
                        Registro de Sesión
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 2 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 2 }) }}>
                        Acuerdos <span className='text-blue f-12 bold ms-2'>{cita.agreements.filter((item) => item.filePath !== null).length}/{cita.agreements.length}</span>
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 3 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 3 }) }}>
                        <div className='bv-icon me-1'><MdTipsAndUpdates></MdTipsAndUpdates></div>
                        <div>Tips </div>
                        <span className='text-blue f-12 bold ms-2'>{cita.tips.length}</span>
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 4 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 4 }) }}>
                        <div className='bv-icon me-1'><AiFillFolder></AiFillFolder></div>
                        <div>Documentos</div>
                        <span className='text-blue f-12 bold ms-2'>{cita.documents.length}</span>
                    </div>
                </div>
            </div>

            <Renderif isTrue={state.tab === 0}>
                <div>
                    <div className='text-gray f-12 p-2'>
                        {cita?.generalInformation}
                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 1}>
                <div>
                    <div className='text-gray f-12 p-2'>
                        {cita?.sessionRecord}
                    </div>
                </div>
            </Renderif>


            <Renderif isTrue={state.tab === 2}>
                <div className=' d-flex '>
                    <div className='col'>

                        {
                            cita.agreements.map((agreement, i) => {
                                return (
                                    <div key={i} className={`p-2 d-flex ${i % 2 == 0 ? 'bg-white' : ''}`}>

                                        {/* <CheckBox disabled={true} checked={agreement.filePath !== null ? true : false} text={agreement?.agreementTitle}/> */}
                                        <CheckBox text={agreement?.agreementTitle} id={agreement?.id} checked={agreement?.isDone} />
                                        <div className='col'></div>
                                        <Renderif isTrue={agreement.filePath !== null ? true : false}>
                                            <div className='bv-pill bv-pill--primary cursor-pointer'>{'Ver Archivo'}</div>
                                        </Renderif>


                                    </div>
                                )
                            })
                        }

                        {/* <div className='p-2 d-flex bg-white'>
                            <CheckBox text={agreement.agreementTitle}/>
                        </div> */}



                    </div>

                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 3}>
                <div className='overflow-auto no-wrap px-2 pb-4 pt-1 w-100 hide-scroll'>

                    {cita.tips.map((item, i) => {
                        console.log(item)
                        return (
                            <div className='w-25-50-100 d-inline-block pe-2' key={i}>
                                <div className='bv-card w-100'>
                                    {/* <div className='bv-card-img'></div> */}
                                    <div className='f-14 p-1 pb-2 text-gray'>{item.title}</div>
                                    <div className='col'></div>
                                    <div className='d-flex align-items-end'>
                                        <div className='f-12 bold text-blue p-1'>Tip #{i + 1}</div>
                                        <div className='col'></div>
                                        {/* <Renderif isTrue={i===0}> */}
                                        {/* <div className='text-white bg-purple bold f-12 px-3 py-1 my-1'>¡Nuevo!</div> */}
                                        {/* </Renderif> */}
                                        {/* <Renderif isTrue={i===2}> */}
                                        <div className='text-white bg-orange bold f-10 px-3 py-1 my-1'>¡Asignado!</div>
                                        {/* </Renderif> */}

                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 4}>
                <div className=' d-flex '>
                    <div className='col'>


                        {cita.documents.map((item, i) => {
                            return (
                                <div className='p-2 d-flex align-items-center bg-white'>

                                    <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                                    <div className='f-12 text-gray ps-2'>{item.title}</div>
                                    <div className='col'></div>
                                    <div className='bv-pill bv-pill--primary cursor-pointer'>Ver Archivo</div>
                                </div>
                            )
                        })}


                    </div>

                </div>
            </Renderif>

        </div>
    )
}

const CitaItem = ({ ...props }) => {
    return (
        <div className='b-bottom align-items-start p-1 highlight-hover--light'>

            <div className='d-flex'>
                <div>
                    <div className='text-gray f-12 bold'>Dr. Ray Marqueda Mejia</div>
                    <div className='text-gray f-10'>Variatra</div>
                </div>
                <div className='col'></div>
                <div className='f-10 bold text-gray'>
                    #AT318790 <MdKeyboardArrowRight color='gray' size={16}></MdKeyboardArrowRight>
                </div>
            </div>
            <div className='d-flex mt-2'>
                <div className='d-flex justify-content-start'>
                    <div className='text-gray f-10'>Jul 13 2023, </div>
                </div>
                <div className='d-flex justify-content-center ps-1'>
                    <div className='text-gray f-10'>5:25 PM</div>
                </div>



                <div className='d-flex justify-content-end ps-2'>
                    <div className='text-gray f-10'>Sesión: <span className='bold text-black'>5</span></div>
                </div>
            </div>




        </div>
    )
}
